import { ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content";
import { HotelFilter } from "@website/accommodation-ui/hotel-filter";
import { HotelListHeader } from "@website/accommodation-ui/hotel-list-header";
import { HotelPagination } from "@website/accommodation-ui/hotel-pagination";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { HotelUpdateSearchModal } from "@website/accommodation-ui/hotel-update-search-modal";
import { VillaMeta } from "@website/accommodation-ui/villa-meta";
import { VillaSearch } from "@website/accommodation-ui/villa-search";
import { MaterialIcon } from "@website/icons/material";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { isChannel } from "@website/utils/channel/helpers";
import { BannerSlide } from "@website/widget/banner-slide";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { AnimatedButton } from "@website/widget/search-map/animatedButton";
import { SeoComponents } from "@website/widget/seo-components";
import { Telesales } from "@website/widget/telesales";
import { NextPage } from "next";
import { useRouter } from "next/router";
import Custom404 from "../../[...gone].page";
import { useCityPage } from "./index.hook";
import { CityPagePropertiesType } from "./index.types";
const Index: NextPage<CityPagePropertiesType> = properties => {
  if (!properties.locationData) {
    return <Custom404 />;
  }
  const router = useRouter();
  const {
    headerProps,
    modalProps,
    searchProperties,
    citiesFilterProperties,
    hotelListHeaderProps,
    hotelPaginationProps,
    hotelCitiesMainContentProps,
    hotelBreadcrumbsProperties,
    telesaleProperties,
    bannersProperties,
    onMapClick,
    hasMap
  } = useCityPage(properties);
  const zinStoryTag = `${router?.query?.locationType}/${router?.query?.cityTitle}`;
  return <>
      <VillaMeta title={properties?.seoData?.title} description={properties?.seoData?.description} locationType={properties.locationData?.type} locationTitle={properties.locationData?.title} />
      <div className="bg-dim-background">
        <HotelUpdateSearchModal {...modalProps} />
        <Header {...headerProps} />
        <div className="bg-outline-thin h-px w-full" />
        <VillaSearch {...searchProperties} />
        <div className="flex flex-col gap-5 px-6 lg:py-5 xl:mx-auto xl:max-w-[1200px] xl:px-0">
          <div className="hidden lg:flex">
            <Breadcrumb {...hotelBreadcrumbsProperties} className="hidden lg:flex" />
          </div>
          <div className="relative flex">
            <div className="p-0">
              {bannersProperties?.bannerSlideList?.length > 0 && <div className="hidden w-[312px] pb-4 xl:block">
                  <BannerSlide className="p-0" list={bannersProperties?.bannerSlideList} />
                </div>}
              <HotelFilter {...citiesFilterProperties} />
            </div>
            <main className="flex min-w-0 shrink grow flex-col gap-5 lg:gap-4">
              <HotelListHeader {...hotelListHeaderProps} />

              <HotelShortVideos className="bg-on-color-high-emphasis -mx-6 -mt-5 px-4 lg:m-0 lg:hidden" displayType={"STORY"} displayId={ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE} zinKey={ZIN_KEY} zinTags={zinStoryTag} />

              <HotelPagination {...hotelPaginationProps}>
                <HotelCitiesMainContent {...hotelCitiesMainContentProps} />
              </HotelPagination>
              {hasMap && <AnimatedButton className="bottom-[20px] self-center md:bottom-6 md:!self-auto xl:!hidden" icon={<MaterialIcon name="map" variant="outlined" />} onClick={onMapClick} text="نمایش اقامتگاه‌ها روی نقشه" />}
            </main>
          </div>
          <div className="w-full px-6 py-2 xl:mx-auto xl:max-w-[1200px]">
            <SeoComponents seoData={properties.seoData} linksTitle="اجاره اقامتگاه در شهرهای پرطرفدار" />
          </div>
          {!isChannel(["b2b", "telesale"]) && <Telesales {...telesaleProperties} />}
          <Footer />
        </div>
      </div>
    </>;
};
export default Index;
export { getServerSideProps } from "./index.server";